(function () {
  function ready(callback) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', callback);
    else callback();
  }

  ready(function () {
    var sticky = document.querySelector('[data-arcvsh-sticky-purchase]');
    if (!sticky) return;

    var productForm = document.querySelector('.product-form');
    var addButton = productForm && productForm.querySelector('[data-add-to-cart]');
    var stickyButton = sticky.querySelector('[data-arcvsh-sticky-add]');
    var stickyVariant = sticky.querySelector('[data-arcvsh-sticky-variant]');
    var variantSelect = productForm && productForm.querySelector('[data-product-select]');
    var footer = document.querySelector('.arcvsh-site-footer');
    if (!productForm || !addButton || !stickyButton) return;

    function sync() {
      var selected = variantSelect && variantSelect.options[variantSelect.selectedIndex];
      if (selected && stickyVariant) stickyVariant.textContent = selected.textContent.trim();
      stickyButton.disabled = addButton.disabled;
      stickyButton.textContent = addButton.disabled ? 'Sold out' : 'Add to Bag';
    }

    function position() {
      if (!window.matchMedia('(max-width: 900px)').matches) {
        sticky.hidden = true;
        return;
      }
      var addRect = addButton.getBoundingClientRect();
      var footerReached = footer && footer.getBoundingClientRect().top < window.innerHeight;
      sticky.hidden = !(addRect.bottom < 0 && !footerReached);
    }

    var ticking = false;
    function requestPosition() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        position();
        ticking = false;
      });
    }

    stickyButton.addEventListener('click', function () {
      if (!addButton.disabled) addButton.click();
    });
    productForm.addEventListener('change', function () {
      window.setTimeout(sync, 80);
    });
    window.addEventListener('scroll', requestPosition, { passive: true });
    window.addEventListener('resize', requestPosition);
    sync();
    position();
  });
})();
